import { hasCapability, type User } from "../base";

export const phaseDuration = {
  read: (user: User) => hasCapability(user, "phaseDuration.read"),
};
